<template>
  <img
    class="cld-responsive"
    :data-src="cloudinaryUrl"
    :alt="alt"
  />
</template>

<script>
import { cl } from '@/main'

export default {
  name: 'ResponsiveImg',
  props: {
    src: String,
    alt: String
  },
  computed: {
    cloudinaryUrl: function () {
      return cl.url(this.src, {
        width: 'auto',
        dpr: 'auto',
        responsive: true,
        crop: 'fit',
        quality: 'auto',
        fetchFormat: 'auto'
      })
    }
  }
}
</script>
